// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * Types of template sections
 */
export var TemplateSectionType;
(function (TemplateSectionType) {
    TemplateSectionType["INVALID_SECTION_TYPE"] = "INVALID_SECTION_TYPE";
    TemplateSectionType["SMS_BODY"] = "SMS_BODY";
    TemplateSectionType["EMAIL_HEADER"] = "EMAIL_HEADER";
    TemplateSectionType["EMAIL_BODY"] = "EMAIL_BODY";
    TemplateSectionType["EMAIL_FOOTER"] = "EMAIL_FOOTER";
    TemplateSectionType["ROBOCALL_BODY"] = "ROBOCALL_BODY";
})(TemplateSectionType || (TemplateSectionType = {}));
export var TemplateSectionType_index;
(function (TemplateSectionType_index) {
    TemplateSectionType_index[TemplateSectionType_index["INVALID_SECTION_TYPE"] = 0] = "INVALID_SECTION_TYPE";
    TemplateSectionType_index[TemplateSectionType_index["SMS_BODY"] = 1] = "SMS_BODY";
    TemplateSectionType_index[TemplateSectionType_index["EMAIL_HEADER"] = 10] = "EMAIL_HEADER";
    TemplateSectionType_index[TemplateSectionType_index["EMAIL_BODY"] = 11] = "EMAIL_BODY";
    TemplateSectionType_index[TemplateSectionType_index["EMAIL_FOOTER"] = 12] = "EMAIL_FOOTER";
    TemplateSectionType_index[TemplateSectionType_index["ROBOCALL_BODY"] = 20] = "ROBOCALL_BODY";
})(TemplateSectionType_index || (TemplateSectionType_index = {}));
export var AutoMessageType_Slug;
(function (AutoMessageType_Slug) {
    AutoMessageType_Slug["UNSPECIFIED_SLUG"] = "UNSPECIFIED_SLUG";
    AutoMessageType_Slug["APPOINTMENT_REMINDER"] = "APPOINTMENT_REMINDER";
    AutoMessageType_Slug["APPOINTMENT_REMINDER_PET"] = "APPOINTMENT_REMINDER_PET";
    AutoMessageType_Slug["APPOINTMENT_FOLLOWUP"] = "APPOINTMENT_FOLLOWUP";
    AutoMessageType_Slug["APPOINTMENT_FOLLOWUP_PET"] = "APPOINTMENT_FOLLOWUP_PET";
    AutoMessageType_Slug["REACTIVATION"] = "REACTIVATION";
    AutoMessageType_Slug["REACTIVATION_PET"] = "REACTIVATION_PET";
    AutoMessageType_Slug["RESCHEDULE"] = "RESCHEDULE";
    AutoMessageType_Slug["RESCHEDULE_PET"] = "RESCHEDULE_PET";
    AutoMessageType_Slug["SAVE_THE_DATE"] = "SAVE_THE_DATE";
    AutoMessageType_Slug["SAVE_THE_DATE_PET"] = "SAVE_THE_DATE_PET";
    AutoMessageType_Slug["BIRTHDAY_MESSAGE"] = "BIRTHDAY_MESSAGE";
    AutoMessageType_Slug["BIRTHDAY_MESSAGE_PET"] = "BIRTHDAY_MESSAGE_PET";
    AutoMessageType_Slug["MISSED_CALL"] = "MISSED_CALL";
    AutoMessageType_Slug["MISSED_TEXT"] = "MISSED_TEXT";
    AutoMessageType_Slug["ORDER_READY"] = "ORDER_READY";
    AutoMessageType_Slug["ORDER_FOLLOWUP"] = "ORDER_FOLLOWUP";
    AutoMessageType_Slug["RECALL_REMINDER"] = "RECALL_REMINDER";
    AutoMessageType_Slug["RECALL_REMINDER_PET"] = "RECALL_REMINDER_PET";
    AutoMessageType_Slug["REVIEW_REQUEST"] = "REVIEW_REQUEST";
    AutoMessageType_Slug["REVIEW_REQUEST_PET"] = "REVIEW_REQUEST_PET";
    AutoMessageType_Slug["CONFIRMED_APPOINTMENT"] = "CONFIRMED_APPOINTMENT";
    AutoMessageType_Slug["CONFIRMED_APPOINTMENT_PET"] = "CONFIRMED_APPOINTMENT_PET";
    AutoMessageType_Slug["PAYMENT_REMINDER"] = "PAYMENT_REMINDER";
})(AutoMessageType_Slug || (AutoMessageType_Slug = {}));
export var AutoMessageType_Slug_index;
(function (AutoMessageType_Slug_index) {
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["UNSPECIFIED_SLUG"] = 0] = "UNSPECIFIED_SLUG";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["APPOINTMENT_REMINDER"] = 1] = "APPOINTMENT_REMINDER";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["APPOINTMENT_REMINDER_PET"] = 2] = "APPOINTMENT_REMINDER_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["APPOINTMENT_FOLLOWUP"] = 10] = "APPOINTMENT_FOLLOWUP";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["APPOINTMENT_FOLLOWUP_PET"] = 11] = "APPOINTMENT_FOLLOWUP_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["REACTIVATION"] = 12] = "REACTIVATION";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["REACTIVATION_PET"] = 13] = "REACTIVATION_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["RESCHEDULE"] = 14] = "RESCHEDULE";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["RESCHEDULE_PET"] = 15] = "RESCHEDULE_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["SAVE_THE_DATE"] = 20] = "SAVE_THE_DATE";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["SAVE_THE_DATE_PET"] = 21] = "SAVE_THE_DATE_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["BIRTHDAY_MESSAGE"] = 30] = "BIRTHDAY_MESSAGE";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["BIRTHDAY_MESSAGE_PET"] = 31] = "BIRTHDAY_MESSAGE_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["MISSED_CALL"] = 40] = "MISSED_CALL";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["MISSED_TEXT"] = 41] = "MISSED_TEXT";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["ORDER_READY"] = 50] = "ORDER_READY";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["ORDER_FOLLOWUP"] = 51] = "ORDER_FOLLOWUP";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["RECALL_REMINDER"] = 60] = "RECALL_REMINDER";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["RECALL_REMINDER_PET"] = 61] = "RECALL_REMINDER_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["REVIEW_REQUEST"] = 70] = "REVIEW_REQUEST";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["REVIEW_REQUEST_PET"] = 71] = "REVIEW_REQUEST_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["CONFIRMED_APPOINTMENT"] = 80] = "CONFIRMED_APPOINTMENT";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["CONFIRMED_APPOINTMENT_PET"] = 81] = "CONFIRMED_APPOINTMENT_PET";
    AutoMessageType_Slug_index[AutoMessageType_Slug_index["PAYMENT_REMINDER"] = 90] = "PAYMENT_REMINDER";
})(AutoMessageType_Slug_index || (AutoMessageType_Slug_index = {}));
export var AutoMessageType_SummaryDisplayType;
(function (AutoMessageType_SummaryDisplayType) {
    AutoMessageType_SummaryDisplayType["NONE"] = "NONE";
    AutoMessageType_SummaryDisplayType["SEND_WINDOW"] = "SEND_WINDOW";
    AutoMessageType_SummaryDisplayType["OFFICE_STATUS"] = "OFFICE_STATUS";
})(AutoMessageType_SummaryDisplayType || (AutoMessageType_SummaryDisplayType = {}));
export var AutoMessageType_SummaryDisplayType_index;
(function (AutoMessageType_SummaryDisplayType_index) {
    AutoMessageType_SummaryDisplayType_index[AutoMessageType_SummaryDisplayType_index["NONE"] = 0] = "NONE";
    AutoMessageType_SummaryDisplayType_index[AutoMessageType_SummaryDisplayType_index["SEND_WINDOW"] = 1] = "SEND_WINDOW";
    AutoMessageType_SummaryDisplayType_index[AutoMessageType_SummaryDisplayType_index["OFFICE_STATUS"] = 2] = "OFFICE_STATUS";
})(AutoMessageType_SummaryDisplayType_index || (AutoMessageType_SummaryDisplayType_index = {}));
export var TemplateOption_TemplateIncludeType;
(function (TemplateOption_TemplateIncludeType) {
    TemplateOption_TemplateIncludeType["AVAILABLE"] = "AVAILABLE";
    TemplateOption_TemplateIncludeType["PROVIDED"] = "PROVIDED";
    TemplateOption_TemplateIncludeType["REQUIRED"] = "REQUIRED";
})(TemplateOption_TemplateIncludeType || (TemplateOption_TemplateIncludeType = {}));
export var TemplateOption_TemplateIncludeType_index;
(function (TemplateOption_TemplateIncludeType_index) {
    TemplateOption_TemplateIncludeType_index[TemplateOption_TemplateIncludeType_index["AVAILABLE"] = 0] = "AVAILABLE";
    TemplateOption_TemplateIncludeType_index[TemplateOption_TemplateIncludeType_index["PROVIDED"] = 1] = "PROVIDED";
    TemplateOption_TemplateIncludeType_index[TemplateOption_TemplateIncludeType_index["REQUIRED"] = 2] = "REQUIRED";
})(TemplateOption_TemplateIncludeType_index || (TemplateOption_TemplateIncludeType_index = {}));
export var Filter_Operator;
(function (Filter_Operator) {
    Filter_Operator["UNSPECIFIED_OPERATOR"] = "UNSPECIFIED_OPERATOR";
    Filter_Operator["IN"] = "IN";
    Filter_Operator["NOT_IN"] = "NOT_IN";
})(Filter_Operator || (Filter_Operator = {}));
export var Filter_Operator_index;
(function (Filter_Operator_index) {
    Filter_Operator_index[Filter_Operator_index["UNSPECIFIED_OPERATOR"] = 0] = "UNSPECIFIED_OPERATOR";
    Filter_Operator_index[Filter_Operator_index["IN"] = 1] = "IN";
    Filter_Operator_index[Filter_Operator_index["NOT_IN"] = 2] = "NOT_IN";
})(Filter_Operator_index || (Filter_Operator_index = {}));
export var ProcessingStrategy_Enum;
(function (ProcessingStrategy_Enum) {
    ProcessingStrategy_Enum["INVALID"] = "INVALID";
    ProcessingStrategy_Enum["ON_SYNC"] = "ON_SYNC";
    ProcessingStrategy_Enum["RELATIVE"] = "RELATIVE";
    ProcessingStrategy_Enum["ANNIVERSARY"] = "ANNIVERSARY";
})(ProcessingStrategy_Enum || (ProcessingStrategy_Enum = {}));
export var ProcessingStrategy_Enum_index;
(function (ProcessingStrategy_Enum_index) {
    ProcessingStrategy_Enum_index[ProcessingStrategy_Enum_index["INVALID"] = 0] = "INVALID";
    ProcessingStrategy_Enum_index[ProcessingStrategy_Enum_index["ON_SYNC"] = 1] = "ON_SYNC";
    ProcessingStrategy_Enum_index[ProcessingStrategy_Enum_index["RELATIVE"] = 2] = "RELATIVE";
    ProcessingStrategy_Enum_index[ProcessingStrategy_Enum_index["ANNIVERSARY"] = 3] = "ANNIVERSARY";
})(ProcessingStrategy_Enum_index || (ProcessingStrategy_Enum_index = {}));
export var OffsetType_Enum;
(function (OffsetType_Enum) {
    OffsetType_Enum["INVALID"] = "INVALID";
    OffsetType_Enum["NO_OFFSET"] = "NO_OFFSET";
    OffsetType_Enum["HOURS_OFFSET"] = "HOURS_OFFSET";
    OffsetType_Enum["DAYS_OFFSET"] = "DAYS_OFFSET";
    OffsetType_Enum["WEEKS_OFFSET"] = "WEEKS_OFFSET";
    OffsetType_Enum["MONTHS_OFFSET"] = "MONTHS_OFFSET";
    OffsetType_Enum["SELECTED_DAYS_OFFSET"] = "SELECTED_DAYS_OFFSET";
})(OffsetType_Enum || (OffsetType_Enum = {}));
export var OffsetType_Enum_index;
(function (OffsetType_Enum_index) {
    OffsetType_Enum_index[OffsetType_Enum_index["INVALID"] = 0] = "INVALID";
    OffsetType_Enum_index[OffsetType_Enum_index["NO_OFFSET"] = 1] = "NO_OFFSET";
    OffsetType_Enum_index[OffsetType_Enum_index["HOURS_OFFSET"] = 2] = "HOURS_OFFSET";
    OffsetType_Enum_index[OffsetType_Enum_index["DAYS_OFFSET"] = 3] = "DAYS_OFFSET";
    OffsetType_Enum_index[OffsetType_Enum_index["WEEKS_OFFSET"] = 4] = "WEEKS_OFFSET";
    OffsetType_Enum_index[OffsetType_Enum_index["MONTHS_OFFSET"] = 5] = "MONTHS_OFFSET";
    OffsetType_Enum_index[OffsetType_Enum_index["SELECTED_DAYS_OFFSET"] = 6] = "SELECTED_DAYS_OFFSET";
})(OffsetType_Enum_index || (OffsetType_Enum_index = {}));
export var OffsetDirection_Enum;
(function (OffsetDirection_Enum) {
    OffsetDirection_Enum["INVALID"] = "INVALID";
    OffsetDirection_Enum["NO_OFFSET"] = "NO_OFFSET";
    OffsetDirection_Enum["PRE_TRIGGER"] = "PRE_TRIGGER";
    OffsetDirection_Enum["POST_TRIGGER"] = "POST_TRIGGER";
})(OffsetDirection_Enum || (OffsetDirection_Enum = {}));
export var OffsetDirection_Enum_index;
(function (OffsetDirection_Enum_index) {
    OffsetDirection_Enum_index[OffsetDirection_Enum_index["INVALID"] = 0] = "INVALID";
    OffsetDirection_Enum_index[OffsetDirection_Enum_index["NO_OFFSET"] = 1] = "NO_OFFSET";
    OffsetDirection_Enum_index[OffsetDirection_Enum_index["PRE_TRIGGER"] = 2] = "PRE_TRIGGER";
    OffsetDirection_Enum_index[OffsetDirection_Enum_index["POST_TRIGGER"] = 3] = "POST_TRIGGER";
})(OffsetDirection_Enum_index || (OffsetDirection_Enum_index = {}));
export var FormsIntegrationStrategy_Enum;
(function (FormsIntegrationStrategy_Enum) {
    FormsIntegrationStrategy_Enum["FORMS_INTEGRATION_STRATEGY_NONE"] = "FORMS_INTEGRATION_STRATEGY_NONE";
    FormsIntegrationStrategy_Enum["NO_EXPIRATION"] = "NO_EXPIRATION";
    FormsIntegrationStrategy_Enum["EXPIRATION_1_HOUR_POST_TRIGGER"] = "EXPIRATION_1_HOUR_POST_TRIGGER";
    FormsIntegrationStrategy_Enum["EXPIRATION_15_DAYS_POST_MESSAGE"] = "EXPIRATION_15_DAYS_POST_MESSAGE";
})(FormsIntegrationStrategy_Enum || (FormsIntegrationStrategy_Enum = {}));
export var FormsIntegrationStrategy_Enum_index;
(function (FormsIntegrationStrategy_Enum_index) {
    FormsIntegrationStrategy_Enum_index[FormsIntegrationStrategy_Enum_index["FORMS_INTEGRATION_STRATEGY_NONE"] = 0] = "FORMS_INTEGRATION_STRATEGY_NONE";
    FormsIntegrationStrategy_Enum_index[FormsIntegrationStrategy_Enum_index["NO_EXPIRATION"] = 1] = "NO_EXPIRATION";
    FormsIntegrationStrategy_Enum_index[FormsIntegrationStrategy_Enum_index["EXPIRATION_1_HOUR_POST_TRIGGER"] = 2] = "EXPIRATION_1_HOUR_POST_TRIGGER";
    FormsIntegrationStrategy_Enum_index[FormsIntegrationStrategy_Enum_index["EXPIRATION_15_DAYS_POST_MESSAGE"] = 3] = "EXPIRATION_15_DAYS_POST_MESSAGE";
})(FormsIntegrationStrategy_Enum_index || (FormsIntegrationStrategy_Enum_index = {}));
export var CallToAction_Enum;
(function (CallToAction_Enum) {
    CallToAction_Enum["NONE"] = "NONE";
    CallToAction_Enum["CONFIRM_APPOINTMENT"] = "CONFIRM_APPOINTMENT";
    CallToAction_Enum["ONLINE_SCHEDULING"] = "ONLINE_SCHEDULING";
    CallToAction_Enum["REVIEW_REQUEST"] = "REVIEW_REQUEST";
})(CallToAction_Enum || (CallToAction_Enum = {}));
export var CallToAction_Enum_index;
(function (CallToAction_Enum_index) {
    CallToAction_Enum_index[CallToAction_Enum_index["NONE"] = 0] = "NONE";
    CallToAction_Enum_index[CallToAction_Enum_index["CONFIRM_APPOINTMENT"] = 1] = "CONFIRM_APPOINTMENT";
    CallToAction_Enum_index[CallToAction_Enum_index["ONLINE_SCHEDULING"] = 2] = "ONLINE_SCHEDULING";
    CallToAction_Enum_index[CallToAction_Enum_index["REVIEW_REQUEST"] = 3] = "REVIEW_REQUEST";
})(CallToAction_Enum_index || (CallToAction_Enum_index = {}));
export var MessageDeadlineType_Enum;
(function (MessageDeadlineType_Enum) {
    MessageDeadlineType_Enum["NONE"] = "NONE";
    MessageDeadlineType_Enum["TRIGGER_AT"] = "TRIGGER_AT";
})(MessageDeadlineType_Enum || (MessageDeadlineType_Enum = {}));
export var MessageDeadlineType_Enum_index;
(function (MessageDeadlineType_Enum_index) {
    MessageDeadlineType_Enum_index[MessageDeadlineType_Enum_index["NONE"] = 0] = "NONE";
    MessageDeadlineType_Enum_index[MessageDeadlineType_Enum_index["TRIGGER_AT"] = 1] = "TRIGGER_AT";
})(MessageDeadlineType_Enum_index || (MessageDeadlineType_Enum_index = {}));
export var PersonStrategy_Enum;
(function (PersonStrategy_Enum) {
    PersonStrategy_Enum["INVALID"] = "INVALID";
    PersonStrategy_Enum["DEFAULT"] = "DEFAULT";
    PersonStrategy_Enum["GROUPED"] = "GROUPED";
    PersonStrategy_Enum["STRANGER"] = "STRANGER";
})(PersonStrategy_Enum || (PersonStrategy_Enum = {}));
export var PersonStrategy_Enum_index;
(function (PersonStrategy_Enum_index) {
    PersonStrategy_Enum_index[PersonStrategy_Enum_index["INVALID"] = 0] = "INVALID";
    PersonStrategy_Enum_index[PersonStrategy_Enum_index["DEFAULT"] = 1] = "DEFAULT";
    PersonStrategy_Enum_index[PersonStrategy_Enum_index["GROUPED"] = 2] = "GROUPED";
    PersonStrategy_Enum_index[PersonStrategy_Enum_index["STRANGER"] = 3] = "STRANGER";
})(PersonStrategy_Enum_index || (PersonStrategy_Enum_index = {}));
export var CooldownScope_Enum;
(function (CooldownScope_Enum) {
    CooldownScope_Enum["NONE"] = "NONE";
    CooldownScope_Enum["RULE"] = "RULE";
    CooldownScope_Enum["AUTO_MESSAGE_TYPES"] = "AUTO_MESSAGE_TYPES";
})(CooldownScope_Enum || (CooldownScope_Enum = {}));
export var CooldownScope_Enum_index;
(function (CooldownScope_Enum_index) {
    CooldownScope_Enum_index[CooldownScope_Enum_index["NONE"] = 0] = "NONE";
    CooldownScope_Enum_index[CooldownScope_Enum_index["RULE"] = 1] = "RULE";
    CooldownScope_Enum_index[CooldownScope_Enum_index["AUTO_MESSAGE_TYPES"] = 2] = "AUTO_MESSAGE_TYPES";
})(CooldownScope_Enum_index || (CooldownScope_Enum_index = {}));
export var MaxAppointmentCheck_Enum;
(function (MaxAppointmentCheck_Enum) {
    MaxAppointmentCheck_Enum["NONE"] = "NONE";
    MaxAppointmentCheck_Enum["FUTURE_APPOINTMENT"] = "FUTURE_APPOINTMENT";
    MaxAppointmentCheck_Enum["RECENT_OR_FUTURE_APPOINTMENT"] = "RECENT_OR_FUTURE_APPOINTMENT";
    MaxAppointmentCheck_Enum["NOT_MAX_APPOINTMENT"] = "NOT_MAX_APPOINTMENT";
})(MaxAppointmentCheck_Enum || (MaxAppointmentCheck_Enum = {}));
export var MaxAppointmentCheck_Enum_index;
(function (MaxAppointmentCheck_Enum_index) {
    MaxAppointmentCheck_Enum_index[MaxAppointmentCheck_Enum_index["NONE"] = 0] = "NONE";
    MaxAppointmentCheck_Enum_index[MaxAppointmentCheck_Enum_index["FUTURE_APPOINTMENT"] = 1] = "FUTURE_APPOINTMENT";
    MaxAppointmentCheck_Enum_index[MaxAppointmentCheck_Enum_index["RECENT_OR_FUTURE_APPOINTMENT"] = 2] = "RECENT_OR_FUTURE_APPOINTMENT";
    MaxAppointmentCheck_Enum_index[MaxAppointmentCheck_Enum_index["NOT_MAX_APPOINTMENT"] = 3] = "NOT_MAX_APPOINTMENT";
})(MaxAppointmentCheck_Enum_index || (MaxAppointmentCheck_Enum_index = {}));
/**
 * The strategy used to evaluate the features.
 */
export var FeaturesEvalStrategy_Enum;
(function (FeaturesEvalStrategy_Enum) {
    FeaturesEvalStrategy_Enum["INVALID"] = "INVALID";
    FeaturesEvalStrategy_Enum["ALL"] = "ALL";
    FeaturesEvalStrategy_Enum["ANY"] = "ANY";
})(FeaturesEvalStrategy_Enum || (FeaturesEvalStrategy_Enum = {}));
export var FeaturesEvalStrategy_Enum_index;
(function (FeaturesEvalStrategy_Enum_index) {
    FeaturesEvalStrategy_Enum_index[FeaturesEvalStrategy_Enum_index["INVALID"] = 0] = "INVALID";
    FeaturesEvalStrategy_Enum_index[FeaturesEvalStrategy_Enum_index["ALL"] = 1] = "ALL";
    FeaturesEvalStrategy_Enum_index[FeaturesEvalStrategy_Enum_index["ANY"] = 2] = "ANY";
})(FeaturesEvalStrategy_Enum_index || (FeaturesEvalStrategy_Enum_index = {}));
